import { init } from './init';
import { onInvokeFinished } from './bridges';
import { subscribeHandler } from './bridges';
import APIS from './apis';
import { reporter } from './shared/reporter';

// 将 API 挂载到全局 window.ma 上
window.ma = APIS;

// 执行初始化逻辑
if (document.readyState !== 'loading') {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init);
}

// 全局 JS 错误监听
window.onerror = function (message, source, lineno, colno, error) {
  try {
    const { stack = 'No stack trace' } = error instanceof Error ? error : {};

    // 上报错误信息到管理台
    reporter.normalError({
      key: 'jsRuntimeError',
      message: message || 'Unknown error',
      stack,
      file: source || 'Unknown file',
      line: lineno || 0,
      column: colno || 0
    });
  } catch (e) {
    console.log('Reporter error:', e);
  }
  return false;
};

// 监听未处理的 Promise rejection
window.onunhandledrejection = function (event) {
  const reason = event.reason;

  const message = reason instanceof Error ? reason.message : String(reason);
  const stack = reason instanceof Error ? reason.stack : 'No stack trace';

  // 上报未处理的 Promise 异常
  reporter.normalError({
    key: 'unhandledRejection',
    message,
    stack
  });

  console.log('Unhandled promise rejection:', reason);
  event.preventDefault();
};

// 监听资源加载失败（如 script、image、css 等 404）
window.addEventListener(
  'error',
  event => {
    const { target } = event;

      if (target instanceof HTMLLinkElement) {
        const src = target?.href || 'unknown';
        // 上报 CSS 加载失败
        reporter.normalError({
          key: 'resourceLoadError',
          message: `CSS load failed: ${src}`,
          file: src,
          stack: 'No stack'
        });
        console.log(`CSS load failed: ${src}`);
      } else if (
          target instanceof HTMLScriptElement ||
          target instanceof HTMLImageElement
      ) {
        const src = target.src;
        // 上报 JS/图片 加载失败
        reporter.normalError({
          key: 'resourceLoadError',
          message: `Resource load failed: ${src}`,
          file: src,
          stack: 'No stack'
        });
        console.log(`Resource load failed: ${src}`);
      } else if (target instanceof HTMLIFrameElement) {
        const src = target.src;
        // 上报 iframe 加载失败
        reporter.normalError({
          key: 'resourceLoadError',
          message: `Iframe load failed: ${src}`,
          file: src,
          stack: 'No stack'
        });
        console.log(`Iframe load failed: ${src}`);
      } else {
        // 兜底处理：未知资源类型
        console.log('Unknown resource load error:', target);
        reporter.normalError({
          key: 'resourceLoadError',
          message: `Unknown resource load error`,
          stack: 'No stack'
        });
      }
    },
    true
); // 必须设置 useCapture: true 才能捕获资源加载错误

/**
 * Support use ma.api from window
 */
window.viewLayer = {
  onInvokeFinished,
  subscribeHandler
};

export default APIS;